import React from "react";
import DeviceContext from "../../../service/indentifyDevice";
import "../../../../assets/scss/components/toc/marginFiles/generic/marginSearch.scss";

export interface MarginSearchProps {
	value?: string; // change this if text in search box needs to be cahnged
	searchList: Array<any>; // the whole array that needs to be searched
	searchKey: string; // the key on which we need to search
	classname?: string; // optional class 

	// callback function that will be called on search.
	// filteredArray is the filtered array and sText is the text that is written in search box
	onSearch: (filteredData: Array<any>, sText: string) => void;
}

const MarginSearch: React.FC<MarginSearchProps> = props => {
	const searchEle = React.useRef<HTMLInputElement>(null);

	function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
		// Variable to hold the filtered list before putting into state
		let newList = [];

		// If the search bar isn't empty
		if (e.target.value !== "") {
			// Use .filter() to determine which items should be displayed
			// based on the search terms
			newList = props.searchList.filter((item: any) => {
				// change current item to lowercase
				const lc = item[props.searchKey].toLowerCase();

				// change search term to lowercase
				const filter = e.target.value.toLowerCase();

				// check to see if the current list item includes the search term
				// If it does, it will be added to newList. Using lowercase eliminates
				// issues with capitalization in search terms and search content
				return lc.includes(filter);
			});
		} else {
			// If the search bar is empty, set newList to original task list
			newList = props.searchList;
		}
		
		// Set the filtered state based on what our rules added to newList
		props.onSearch(newList, e.target.value);
	}

	function reset() {
		let ele = document.getElementById("ObTableDataSearchEle") as HTMLInputElement;
		ele.value = "";
		props.onSearch(props.searchList, "");
	}

	return (
		<div className="margin_search">
			<button className="i_search">
				<i className="edel-icon-search"></i>
			</button>
			<input
				value={props.value}
				id="ObTableDataSearchEle"
				ref={searchEle}
				autoFocus
				type="text"
				className={props.classname}
				onChange={handleChange}
				placeholder={DeviceContext().isMobile ? "Eg “INFYJAN20FUT”" : "Search for scrip name, eg “INFYJAN20FUT”"}
				autoComplete="off"
			/>
			{!DeviceContext().isDesktop && searchEle.current?.value !== "" && searchEle.current?.value !== undefined && (
				<button className="i_close edBtn" onClick={() => reset()}>
					<i className="edel-icon-close"></i>
				</button>
			)}
		</div>
	);
};

export default MarginSearch;
